import { combineReducers } from 'redux'

import {
  SELECT_GENDER,
  UPDATE_BIRTHDATE,
  SELECT_OCCUPATION,
  SELECT_NATURE_OF_DUTY,
  SELECT_OTHER_NATURE_OF_DUTY,
  SELECT_OTHER_OCCUPATION,
  TOGGLE_OTHER_OCCUPATION,
  SELECT_PAYER_OTHER_NATURE_OF_DUTY,
  SELECT_PAYER_OTHER_OCCUPATION,
  TOGGLE_PAYER_OTHER_OCCUPATION,
  SELECT_PAYER_GENDER,
  SELECT_PAYER_RELATION,
  UPDATE_PAYER_BIRTHDATE,
  UPDATE_PAYER_NEEDED,
  SET_OCCUPATION_FACTOR,
  UPDATE_OCCUPATION_ERRORS,
  UPDATE_OTHER_OCCUPATION_ERRORS,
  UPDATE_PAYER_OCCUPATION_ERRORS,
  UPDATE_PAYER_OTHER_OCCUPATION_ERRORS,
  SELECT_PAYER_NATURE_OF_DUTY,
  SELECT_PAYER_OCCUPATION,
  CLEAR_PAYER_INFORMATION,
  CLEAR_PAYER_NEEDED,
  PATCH_BIRTHDATE,
  PATCH_PAYER_BIRTHDATE,
  RESET_OCCUPATION,
} from './actions'
import { RESET_APPLICATION_STATE, RESET_QUOTE_FORM } from 'quick-quote/actions'
import { TitleRedux } from './redux/title'
import { FirstNameRedux } from './redux/name'
import { LastNameRedux } from './redux/surname'
import constants from 'core/data-model/constants/defaults'
import { reducer as maturity } from 'quick-quote/product-sio'
import { RESET_QUOTE_FORM_AFTER_MATURITY_VALIDATE } from 'quick-quote/product-sio/actions'

const {
  DEFAULT_PAYER_AGE,
  DEFAULT_PAYER_GENDER,
  DEFAULT_INSURED_AGE,
  DEFAULT_INSURED_GENDER,
  DEFAULT_OCCUPATION_CODE,
  DEFAULT_NATURE_OF_DUTY_CODE,
  DEFAULT_NATURE_OF_DUTY_TEXT,
} = constants

const gender = (state = DEFAULT_INSURED_GENDER, action) => {
  switch (action.type) {
    case RESET_QUOTE_FORM:
    case RESET_QUOTE_FORM_AFTER_MATURITY_VALIDATE:
    case RESET_APPLICATION_STATE:
      return DEFAULT_PAYER_GENDER
    case SELECT_GENDER:
      return action.payload
  }
  return state
}

// birthdate

const initialBirthdateState = {
  value: '',
  errors: [],
}

const birthdate = (state = initialBirthdateState, action) => {
  switch (action.type) {
    case RESET_QUOTE_FORM:
    case RESET_QUOTE_FORM_AFTER_MATURITY_VALIDATE:
    case RESET_APPLICATION_STATE:
      return initialBirthdateState
    case UPDATE_BIRTHDATE:
    case PATCH_BIRTHDATE:
      return {
        value: action.birthdate,
        errors: action.errors,
      }
    default:
      return state
  }
}

const age = (state = DEFAULT_INSURED_AGE, action) => {
  switch (action.type) {
    case RESET_QUOTE_FORM:
    case RESET_QUOTE_FORM_AFTER_MATURITY_VALIDATE:
    case RESET_APPLICATION_STATE:
      return DEFAULT_INSURED_AGE
    case UPDATE_BIRTHDATE:
    case PATCH_BIRTHDATE:
      return action.age
    default:
      return state
  }
}

// occupation

const initialOccupationState = {
  code: DEFAULT_OCCUPATION_CODE,
  natureOfDuty: {
    code: DEFAULT_NATURE_OF_DUTY_CODE,
    text: DEFAULT_NATURE_OF_DUTY_TEXT,
  },
  errors: [],
}

const occupation = (state = initialOccupationState, action) => {
  switch (action.type) {
    case RESET_QUOTE_FORM:
    case RESET_QUOTE_FORM_AFTER_MATURITY_VALIDATE:
    case RESET_APPLICATION_STATE:
    case RESET_OCCUPATION:
      return initialOccupationState
    case SELECT_OCCUPATION:
      return {
        ...state,
        code: action.payload,
      }

    case UPDATE_OCCUPATION_ERRORS:
      return {
        ...state,
        errors: action.payload,
      }

    case SELECT_NATURE_OF_DUTY:
      return {
        ...state,
        natureOfDuty: action.payload,
      }
    ///FIXME why do we need this????
    case SET_OCCUPATION_FACTOR:
      return { ...state, occupationFactor: action.payload }
  }

  return state
}

const initialOtherOccupationState = {
  code: DEFAULT_OCCUPATION_CODE,
  natureOfDuty: {
    code: DEFAULT_NATURE_OF_DUTY_CODE,
    text: DEFAULT_NATURE_OF_DUTY_TEXT,
  },
  errors: [],
  isSelected: false,
}

const otherOccupation = (state = initialOtherOccupationState, action) => {
  switch (action.type) {
    case RESET_QUOTE_FORM:
    case RESET_QUOTE_FORM_AFTER_MATURITY_VALIDATE:
    case RESET_APPLICATION_STATE:
      return initialOtherOccupationState
    case SELECT_OTHER_OCCUPATION:
      return {
        ...state,
        code: action.payload,
      }
    case SELECT_OTHER_NATURE_OF_DUTY:
      return {
        ...state,
        natureOfDuty: action.payload,
      }
    case TOGGLE_OTHER_OCCUPATION:
      return {
        ...state,
        isSelected: !state.isSelected,
      }
    case UPDATE_OTHER_OCCUPATION_ERRORS:
      return {
        ...state,
        errors: action.payload,
      }
  }
  return state
}

const initialPayerState = {
  gender: DEFAULT_PAYER_GENDER,
  birthdate: {
    value: '',
    errors: [],
  },
  age: DEFAULT_PAYER_AGE,
  occupation: initialOccupationState,
  otherOccupation: initialOtherOccupationState,
  relation: constants.PAY_MY_SELF,
}

const payerNeeded = (state = false, action) => {
  switch (action.type) {
    case RESET_QUOTE_FORM:
    case RESET_QUOTE_FORM_AFTER_MATURITY_VALIDATE:
    case RESET_APPLICATION_STATE:
    case CLEAR_PAYER_NEEDED:
      return false
    case UPDATE_PAYER_NEEDED:
      return action.payload
    default:
      return state
  }
}

const payer = (state = initialPayerState, action) => {
  switch (action.type) {
    case RESET_QUOTE_FORM:
    case RESET_QUOTE_FORM_AFTER_MATURITY_VALIDATE:
    case RESET_APPLICATION_STATE:
    case CLEAR_PAYER_INFORMATION:
      return initialPayerState
    case SELECT_PAYER_GENDER:
      return { ...state, gender: action.payload }
    case SELECT_PAYER_RELATION:
      return { ...state, relation: action.payload }
    case UPDATE_PAYER_BIRTHDATE:
    case PATCH_PAYER_BIRTHDATE:
      return {
        ...state,
        birthdate: {
          value: action.birthdate,
          errors: action.errors,
        },
        age: action.age,
      }
    case SELECT_PAYER_NATURE_OF_DUTY:
      return {
        ...state,
        occupation: {
          ...state.occupation,
          natureOfDuty: action.payload,
        },
      }
    case SELECT_PAYER_OCCUPATION:
      return {
        ...state,
        occupation: {
          ...state.occupation,
          code: action.payload,
        },
      }
    case UPDATE_PAYER_OCCUPATION_ERRORS:
      return {
        ...state,
        occupation: {
          ...state.occupation,
          errors: action.payload,
        },
      }
    case SELECT_PAYER_OTHER_OCCUPATION:
      return {
        ...state,
        otherOccupation: {
          ...state.otherOccupation,
          code: action.payload,
        },
      }
    case SELECT_PAYER_OTHER_NATURE_OF_DUTY:
      return {
        ...state,
        otherOccupation: {
          ...state.otherOccupation,
          natureOfDuty: action.payload,
        },
      }
    case TOGGLE_PAYER_OTHER_OCCUPATION:
      return {
        ...state,
        otherOccupation: {
          ...state.otherOccupation,
          isSelected: !state.otherOccupation.isSelected,
        },
      }
    case UPDATE_PAYER_OTHER_OCCUPATION_ERRORS:
      return {
        ...state,
        otherOccupation: {
          ...state.otherOccupation,
          errors: action.payload,
        },
      }
  }

  return state
}

export const reducer = combineReducers({
  title: TitleRedux.reducer,
  firstName: FirstNameRedux.reducer,
  lastName: LastNameRedux.reducer,
  gender,
  occupation,
  otherOccupation,
  payerNeeded,
  payer,
  birthdate,
  age,
  maturity,
})
